export default "__VITE_ASSET__BhFiQgCE__"